/* 🤖 this file was generated by svg-to-ts */
export const waytrArrowRight = {
    name: 'arrow_right',
    data: `<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.1 48.1"><path d="M10.6,45.15c0,.74,.29,1.49,.85,2.06,1.13,1.13,2.99,1.13,4.12,0l21.08-21.08c.54-.54,.85-1.31,.85-2.06s-.27-1.48-.85-2.06L15.59,.95c-1.11-1.18-3.02-1.19-4.14-.07s-1.13,2.99,0,4.12h0S30.51,24.03,30.51,24.03L11.45,43.09c-.56,.56-.85,1.32-.85,2.06h0Z"/></svg>`,
};
